import React from "react";

export default function WhatsAppFab() {
  const phone = "573021031409";
  const message = encodeURIComponent(
    "Hola! Quiero información sobre Pollagol 2026 ⚽"
  );
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="WhatsApp"
      className="fixed z-50 bottom-6 left-6 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5c] shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-colors">
        <svg
          viewBox="0 0 32 32"
          className="w-7 h-7 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.21c-.27-.13-1.6-.79-1.84-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.14-.42-2.17-1.34-.8-.71-1.34-1.6-1.5-1.87-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.35.98 2.65 1.12 2.83.14.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.56.58.65.21 1.25.18 1.72.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.31z" />
          <path d="M27.27 4.7C24.27 1.7 20.27.02 16 .02 7.18.02.02 7.18.02 16c0 2.82.74 5.58 2.14 8L0 32l8.21-2.15c2.31 1.26 4.91 1.92 7.56 1.92h.01c8.82 0 15.98-7.16 15.98-15.98 0-4.27-1.68-8.27-4.49-11.09zM16 29.13h-.01c-2.36 0-4.68-.63-6.7-1.83l-.48-.29-4.99 1.31 1.33-4.87-.31-.5c-1.32-2.1-2.02-4.53-2.02-7.02 0-7.27 5.92-13.19 13.19-13.19 3.52 0 6.83 1.37 9.32 3.87 2.49 2.5 3.87 5.81 3.87 9.33-.01 7.28-5.92 13.19-13.2 13.19z" />
        </svg>
      </span>
      <span className="hidden md:block absolute right-full top-1/2 -translate-y-1/2 mr-3 whitespace-nowrap px-3 py-1.5 bg-[#0d0d0d] border border-white/15 text-xs uppercase tracking-[0.2em] font-head text-white opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chatea por WhatsApp
      </span>
    </a>
  );
}
